import { useRoutes } from 'react-router-dom';
import { BannedIDPage, BannedPage, RulesPage } from './pages';
import { RoutesNameAntifraud, RoutesName } from './state/constants';

export const AntifraudModule = () => {
  const routes = useRoutes([
    {
      path: RoutesNameAntifraud.banned,
      element: <BannedPage />,
    },
    {
      path: RoutesNameAntifraud.rules,
      element: <RulesPage />,
    },
    {
      path: RoutesNameAntifraud.bannedId,
      element: <BannedIDPage />,
    },
  ]);

  return <>{routes}</>;
};
